import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import web from './views/Web.vue'
import applets from './views/Applets.vue'
import ios from './views/Ios.vue'
import about from './views/About.vue'
import android from './views/Android.vue'
import blend from './views/Blend.vue'
import h5 from './views/H5.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/web',
      name: 'web',
      component: web
    },
    {
      path: '/applets',
      name: 'applets',
      component: applets
    },
    {
      path: '/ios',
      name: 'ios',
      component: ios
    },
    {
      path: '/android',
      name: 'android',
      component: android
    },
    {
      path: '/blend',
      name: 'blend',
      component: blend
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/h5',
      name: 'h5',
      component: h5
    }
  ]
})
